import React from 'react';
import clsx from 'clsx';

const variants = {
  primary: 'bg-wrg-blue-600 hover:bg-wrg-blue-700 text-white focus:ring-wrg-blue-500',
  secondary: 'bg-white hover:bg-slate-50 text-slate-700 border border-slate-300 hover:border-slate-400 focus:ring-slate-400',
  ghost: 'hover:bg-slate-100 text-slate-600 hover:text-slate-800',
  danger: 'bg-red-600 hover:bg-red-700 text-white focus:ring-red-500',
  success: 'bg-green-600 hover:bg-green-700 text-white focus:ring-green-500',
  outline: 'border border-slate-300 text-slate-600 hover:bg-slate-50 hover:text-slate-800 hover:border-slate-400',
  'outline-primary': 'border border-wrg-blue-600 text-wrg-blue-600 hover:bg-wrg-blue-50',
};

const sizes = {
  xs: 'px-2.5 py-1 text-2xs gap-1 h-7',
  sm: 'px-3 py-1.5 text-xs gap-1.5 h-8',
  md: 'px-3.5 py-2 text-sm gap-2 h-9',
  lg: 'px-4 py-2.5 text-base gap-2 h-10',
  icon: 'p-2',
  'icon-sm': 'p-1.5',
};

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className,
  disabled,
  loading,
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
  ...props
}) {
  const iconSize = size === 'xs' || size === 'sm' ? 'w-3.5 h-3.5' : 'w-4 h-4';

  return (
    <button
      className={clsx(
        'inline-flex items-center justify-center font-medium rounded transition-colors duration-100 focus:outline-none focus:ring-2 focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed',
        variants[variant],
        sizes[size],
        className
      )}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <svg className={clsx('animate-spin', iconSize)} viewBox="0 0 24 24">
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
            fill="none"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
          />
        </svg>
      ) : LeftIcon ? (
        <LeftIcon className={iconSize} />
      ) : null}
      {children}
      {RightIcon && !loading && <RightIcon className={iconSize} />}
    </button>
  );
}

export function IconButton({ icon: Icon, className, variant = 'ghost', size = 'icon', ...props }) {
  const iconSize = size === 'icon-sm' ? 'w-4 h-4' : 'w-5 h-5';

  return (
    <button
      className={clsx(
        'inline-flex items-center justify-center rounded transition-colors duration-100 text-slate-500 hover:text-slate-700 hover:bg-slate-100',
        sizes[size],
        className
      )}
      {...props}
    >
      <Icon className={iconSize} />
    </button>
  );
}
